import { render } from "./ProcessComponentsIterator.vue?vue&type=template&id=58a997fa&scoped=true&ts=true"
import script from "./ProcessComponentsIterator.vue?vue&type=script&lang=ts"
export * from "./ProcessComponentsIterator.vue?vue&type=script&lang=ts"

import "./ProcessComponentsIterator.vue?vue&type=style&index=0&id=58a997fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a997fa"]])

export default __exports__